import React, { useMemo } from 'react';
import styles from '../../assets/styles/Button.module.scss';
import { IoCaretForward, IoCaretBack } from 'react-icons/io5';
import { BsThreeDots } from 'react-icons/bs';

const Pagination = ({
	pageSize = 50,
	setPageSize,
	onLimitChange,
	currentPage,
	totalItems,
	pageOptions,
	pageCount,
	previousPage,
	setCurrentPage,
	gotoPage,
	nextPage,
}) => {
	const maxDisplayedPages = 3; // Maximum number of page buttons to display

	const totalPages = totalItems ? Math.ceil(totalItems / pageSize) : pageCount;

	const pageButtons = useMemo(() => {
		let pageButtons = [];
		if (totalPages <= maxDisplayedPages) {
			pageButtons = Array.from({ length: totalPages }, (_, index) => index);
			return pageButtons;
		} else {
			const startPage = Math.max(
				0,
				currentPage - Math.floor(maxDisplayedPages / 2)
			);
			const endPage = Math.min(
				totalPages - 1,
				startPage + maxDisplayedPages - 1
			);

			if (startPage > 0) {
				pageButtons.push('...');
			}

			pageButtons = pageButtons.concat(
				Array.from(
					{ length: endPage - startPage + 1 },
					(_, index) => startPage + index
				)
			);

			if (endPage < totalPages - 1) {
				pageButtons.push('...');
			}
			return pageButtons;
		}
	}, [totalPages, maxDisplayedPages, currentPage]);

	return (
		<div className={styles.pagination__group}>
			<div className={styles.pagination}>
				{onLimitChange ? (
					<select
						value={pageSize}
						onChange={e => {
							setPageSize(Number(e.target.value));
							onLimitChange(Number(e.target.value));
						}}>
						{[50, 200, 300, 400, 500, 1000, 3000, 5000, 6000, 10000 ].map(pageSize => (
							<option key={pageSize} value={pageSize}>
								Show {pageSize}
							</option>
						))}
					</select>
				) : (
					''
				)}
				<strong>
					{currentPage + 1} of {totalItems ? totalPages : pageOptions?.length}
				</strong>
			</div>
			<div className={styles.pagination}>
				<button
					onClick={() => {
						if (previousPage) {
							previousPage();
						}
						setCurrentPage(currentPage - 1);
					}}
					disabled={currentPage === 0}
					className={styles.numberedPage}>
					<IoCaretBack style={{ fontSize: '2rem' }} />
				</button>
				{pageButtons.map((page, index) =>
					page === '...' ? (
						<BsThreeDots key={index} style={{ fontSize: '2rem' }} />
					) : (
						<button
							key={index}
							onClick={() => {
								if (gotoPage) {
									gotoPage(page);
								}
								setCurrentPage(page);
							}}
							className={`${styles.numberedPage} ${currentPage === page ? styles.numberPageActive : ''}`}>
							{page + 1}
						</button>
					)
				)}

				<button
					onClick={() => {
						if (nextPage) {
							nextPage();
						}
						setCurrentPage(currentPage + 1);
					}}
					disabled={currentPage === totalPages - 1}
					className={styles.numberedPage}>
					<IoCaretForward style={{ fontSize: '2rem' }} />
				</button>
			</div>
		</div>
	);
};

export default Pagination;
